// Ensure the coupon block sits immediately after the price block,
// even if third-party scripts (e.g., Affirm) inject elements later.
(function () {
	function placeCouponAfterPrice(priceBlock, couponBlock) {
		if (!priceBlock || !couponBlock) return;
		// If it's already the immediate sibling, do nothing
		if (priceBlock.nextElementSibling === couponBlock) return;
		// Move coupon right after the price block
		priceBlock.insertAdjacentElement('afterend', couponBlock);
	}

	function initCouponPlacement() {
		var priceBlock = document.querySelector('.product-single__prices');
		var couponBlock = document.querySelector('.coupon-code-block');
		if (!priceBlock || !couponBlock) return;

		// Initial placement
		placeCouponAfterPrice(priceBlock, couponBlock);

		// Observe sibling changes so we keep coupon directly after the price
		var parent = priceBlock.parentNode;
		if (!parent) return;

		var observer = new MutationObserver(function (mutations) {
			// On any child additions/removals, re-place the coupon immediately after the price
			// This covers elements like <p class="affirm-as-low-as"> injected after the price.
			for (var i = 0; i < mutations.length; i++) {
				var m = mutations[i];
				if (m.type === 'childList' && (m.addedNodes.length || m.removedNodes.length)) {
					placeCouponAfterPrice(priceBlock, couponBlock);
				}
			}
		});

		observer.observe(parent, { childList: true });
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initCouponPlacement);
	} else {
		initCouponPlacement();
	}
})();

